import React from "react";
import { useNavigate } from "react-router-dom";

function PhotoReminderCard() {
  const navigate = useNavigate();

  return (
    <div className="card dashboard-card photo-card">
      <h5>📷 Daily Photo Reminder</h5>

      <p>
        Capture today's vermicompost photo to track
        progress.
      </p>

      <button
        className="btn btn-success"
        onClick={() => navigate("/photos")}
      >
        Take Today's Photo
      </button>
    </div>
  );
}

export default PhotoReminderCard;